<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      :label="label"
      item-text="name"
      item-value="id"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {RewardGeneratorMode} from "@/modules/redactor/models/reward-generator/RewardGeneratorMode";

export default {
  name: "r-reward-generator-mode",
  props: {
    model: VueTypes.instanceOf(RewardGeneratorMode),
    label: VueTypes.string.def("Mode:"),
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return RewardGeneratorMode.getValues();
    }
  }
}
</script>